module.exports = __webpack_public_path__ + "static/media/visa.4adec82c.svg";